module.exports = __webpack_public_path__ + "img/FERODO.967960fa.png";